// extracted by mini-css-extract-plugin
export default {"contentWrapper":"DividerContent_contentWrapper__fi2BU","divider":"DividerContent_divider__2ykDM","content":"DividerContent_content__pVWq6"};